// Ids match what the M5 reseed migration (20260727160000_reseed_purchase_order_statuses)
// actually produces: DELETE + re-INSERT with no explicit ids, continuing the existing
// autoincrement sequence past the 5 rows from the original seed_enumerations migration.
// That migration is already applied in deployed environments and cannot be changed, so
// these numbers must match its real output, not a fresh 1-6 numbering.
export var PurchaseOrderItemStatus;
(function (PurchaseOrderItemStatus) {
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["ENTERED"] = 6] = "ENTERED";
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["SHIPPED"] = 7] = "SHIPPED";
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["PARTIAL"] = 8] = "PARTIAL";
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["FULFILLED"] = 9] = "FULFILLED";
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["SHORT"] = 10] = "SHORT";
    PurchaseOrderItemStatus[PurchaseOrderItemStatus["VOID"] = 11] = "VOID";
})(PurchaseOrderItemStatus || (PurchaseOrderItemStatus = {}));
/** Seeded display names — compare to `status.name` in UI/lifecycle only, not for DB lookups. */
export const purchaseOrderItemStatusName = {
    ENTERED: 'Entered',
    SHIPPED: 'Shipped',
    PARTIAL: 'Partial',
    FULFILLED: 'Fulfilled',
    SHORT: 'Short',
    VOID: 'Void',
};
//# sourceMappingURL=purchase-order-item-status.js.map